import { DomaineJsonldUtilisateurReadDomaineRead as Domaine } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';

export const domainesOptionsSort = (domainesList?: Domaine[]) => {
    // Create options list
    const options =
        domainesList?.map((domaineItem) => ({
            label: domaineItem.ddmLibelle as string,
            value: domaineItem['@id'] as string,
        })) ?? [];

    // If has domaines list
    if (options.length !== 0) {
        // Find base option index
        const defaultOptionIndex = options.findIndex((item) => item.label === 'Pas spécifié');

        // If default option index is found
        if (defaultOptionIndex !== -1) {
            // Extract base option
            const defaultOption = options.splice(defaultOptionIndex, 1);

            // Sort option list
            const sortedOptions = options.sort((a, b) => a.label.localeCompare(b.label));

            // Add base option to the beginning
            sortedOptions.unshift(defaultOption[0]);

            return sortedOptions;
        }
    }

    return options;
};
